module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ../~/prop-types/lib/has.js
// module id = 526
// module chunks = 7